<div class="errwrap">
  <div class="errdiv1" id="errs">
  </div>
</div>
<div 
*ngIf="actionmode == 'Add' || actionmode == 'Edit'"
 class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div 
        *ngIf="actionmode == 'Add' || actionmode == 'Edit'" 
        class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" 
          type="button" (click)="submitData1()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-danger commonbutt" 
          (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>


    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <!-- form starts here  -->
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div 
                style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3">
                    <label>Origin Code</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Origin_Code"
                      placeholder="Enter Origin Code" style="text-transform: uppercase">
                  </div>
                  <div class="col-lg-3">
                    <label>Destination Code</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Destination_Code"
                      placeholder="Enter Destination Code" style="text-transform: uppercase">
                  </div>
                  <div class="col-lg-3">
                    <label>TPM Value</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.TPM_Value"
                      placeholder="Enter TPM Value">
                  </div>
                  <div *ngIf="editFlag==true">
                    <button class="btn btn-primary  commonbutt color" type="button" (click)="Delete()">
                      Delete
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view Details -->
<div [hidden]="!viewpage" class="tdive">
  <div *ngIf="actionmode == 'view'" class="searchdiv">
    <div class="card screen-wrapper">
      <div style="border-bottom:1px solid #ddd9d9;margin-bottom: 15px; ">
        <h4 class="screen-title">{{ screentitle }}</h4>
        <div class="button-wrapper bothbuttdiv2">
          <button style="margin-top: 8px" class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <table aria-describedby="tpmMasterDetails" class="viewtable">
      <div *ngFor="let q of EditData">
        <tr>
          <th scope="col">
            <span class="vlbl">Origin Code</span>
          </th>
          <td>
            <span class="vVal">{{ q.origin }}</span>
          </td>
        </tr>

        <tr>
          <th scope="col">
            <span class="vlbl">Destination Code</span>
          </th>
          <td>
            <span class="vVal">{{ q.destination }}</span>
          </td>
        </tr>
        <tr>
          <th scope="col">
            <span class="vlbl">TPM Value</span>
          </th>
          <td>
            <span class="vVal"> {{ q.tpm_value }} </span>
          </td>
        </tr>
      </div>
    </table>
  </div>
</div>
<!-- End -->
<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>TPM Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>
                    <div class="col-lg-3">
                      <label>Origin Code</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Origin_Code"
                        placeholder="Enter Origin Code" style="text-transform: uppercase">
                    </div>
                    <div class="col-lg-3">
                      <label>Destination Code</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Destination_Code"
                        placeholder="Enter Destination Code" style="text-transform: uppercase">
                    </div>
                    <div class="col-lg-3">
                      <label>TPM Value</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.TPM_Value"
                        placeholder="Enter TPM Value">
                    </div>
                    <div class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                      <span>
                        <button style="margin-top: 20px !important;" class="btn btn-primary  commonbutt" type="button"
                          (click)="getReprt()">
                          Download
                        </button>
                      </span>
                      <span>
                        <button id="uploadbutton" style="font-size: 13px;
                        margin-top: 20px;
                        padding: 3px;" class="btn btn-primary" (click)="Upload()" type="button">
                          <em class="fa fa-search "></em>&nbsp;Upload
                        </button>
                      </span>
                    </div>
                    <div>
                      <input type="file" id="attachment" style="display:none" (change)="fileSelected($event)">
                    </div>
                  </div>
                  <div class="col-md-12" style="margin-top:1%">
                    <button class="btn btn-primary offset-md-3" type="button" (click)="downloadFile()">Download
                      Sample</button>
                    <button class="btn btn-primary offset-md-3 " style="margin-left:2%" type="button"
                      (click)="listDuplicates()">Duplicates</button>
                  </div>
                  <br />

                  <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                    <table aria-describedby="tpmMasterSearchData" class="table table-striped" [mfData]="serachtabledata"
                      [mfRowsOnPage]="5">

                      <tr>
                        <th scope="col" style="width: 10%">Action
                        </th>
                        <th scope="col" style="width: 20%">Origin Code
                        </th>

                        <th scope="col" style="width: 20%">
                          Destination Code
                        </th>
                        <th scope="col" style="width: 20%">
                          TPM Value
                        </th>

                      </tr>
                      <tr *ngFor="let q of (serachtabledata
                        | paginate: { itemsPerPage: 10, currentPage: p,totalItems:totalItems })">
                        <td>
                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,1)">
                            <em class="fa fa-eye"></em>
                          </button>

                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,2)">
                            <em class="fa fa-pencil"></em>
                          </button>

                        </td>

                        <td>
                          <span class="vVal">{{ q.origin }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.destination }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.tpm_value }}</span>
                        </td>
                      </tr>
                      <tfoot>
                        <tr>
                          <td colspan="4">
                            <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                            </pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div *ngIf="duplicateStatus" class="reportstatus">
                    <table aria-describedby="tpmMasterData" class="table table-striped">

                      <tr>
                        <th scope="col" style="width: 20%">Origin Code
                        </th>

                        <th scope="col" style="width: 20%">
                          Destination Code
                        </th>
                        <th scope="col" style="width: 20%">
                          TPM Value
                        </th>
                        <th scope="col">
                          Count
                        </th>
                      </tr>
                      <tr *ngFor="let q of duplicateList">
                        <td>
                          <span class="vVal">{{ q.origin }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.destination }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.tpm_value }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.count }}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>